import { createSelector } from 'reselect';
import SaintPierreEtMiquelonDetailsColumns from '../../containers/SaintPierreEtMiquelonDetailsColumns';
import ReportDefinitions from '../../../../../../common/config/ReportDefinitions';

export const getGeneratedOnDateTime = state => state
  .reporting.SAINT_PIERRE_ET_MIQUELON_DETAILS.metadata.generatedOnDateTime;

export const getIsLoading =
  state => state.reporting.SAINT_PIERRE_ET_MIQUELON_DETAILS.isLoading;

export const getData =
  ReportDefinitions.SAINT_PIERRE_ET_MIQUELON_DETAILS.getDataFunction();

export const getColumns =
  createSelector(getData, SaintPierreEtMiquelonDetailsColumns);
